import { Controller } from '@hotwired/stimulus'
import { toggleVisibility } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static targets = ["fields", "button"]

  toggleFields(e) {
    e.preventDefault()
    toggleVisibility(this.fieldsTarget)
  }

  updateApplyButton(e) {
    const field = e.target
    this.buttonTarget.disabled = field.value.trim() === ""
  }
}
